/**
 * Created by Jonas Wålekvist on 2018-02-22.
 */
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BetLineWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";
import {IIndividualWinPresentationConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Timeline, TimelineLite} from "gsap"
import {IAdjacentBetLineWinData} from "../../utils/SymbolUtil";
import {DirtyWildsGameConfig} from "../DirtyWildsGameConfig";
import {DirtyWildsStateReelSymbol} from "../symbols/DirtyWildsStateReelSymbol";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {DirtyWildsParsedGameData} from "../server/data/DirtyWildsParsedGameData";

export class DirtyWildsBetLineWinIndividualWPController extends BetLineWinIndividualWPController {
    private _waitTimeline:TimelineLite;
    private _isRandomSyncFeatureTriggered:boolean = false;
    constructor(config:IIndividualWinPresentationConfig, name?:string, tweakEnabled?:boolean) {
        super(config, name, tweakEnabled);
    }

    protected startWinPresentation():void{
        this._waitTimeline = new TimelineLite();
        this._waitTimeline.set({}, {}, 1.25);
        if(this._isRandomSyncFeatureTriggered) {
            this._waitTimeline.add(() => this.undimSyncSymbols());
        }
        this._waitTimeline.set({}, {}, 1.5);
        this._waitTimeline.add(() => super.startWinPresentation());
    }

    protected stopWinPresentation(isAborted:boolean):void{
        super.stopWinPresentation(isAborted);
        if(this._waitTimeline !== undefined && this._waitTimeline.isActive()) {
            this._waitTimeline.pause();
            this._waitTimeline.kill();
        }
    }

    protected parseFeatureGameData(data: ParsedGameData):void{
        this._isRandomSyncFeatureTriggered = (<DirtyWildsParsedGameData>data).isRandomSyncFeatureTriggered;
    }

    private undimSyncSymbols():void{
        const inActiveReels: number[] = [0, 4];
        for (let i: number = 0; i < inActiveReels.length; i++) {
            let reelSymbols = <DirtyWildsStateReelSymbol[]>Reels.allSymbols(inActiveReels[i]);
            if (reelSymbols.length > 0) {
                for (let l: number = 0; l < reelSymbols.length; l++) {
                    reelSymbols[l].changeState({
                        state: DirtyWildsGameConfig.instance.SYMBOL_STATES.normal,
                        replay: false,
                        fadeInDuration: 0.2
                    });
                }
            }
        }
    }

    protected getLineAnimation(betLineWinData:IBetLineWinData):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        const reelsInfo:string[][] = this._gameData!.reels;
        timeline.add(() => {
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SHOW_WIN_BET_LINE, betLineWinData));
        });
        for(let i =0; i < 5; i++){
                for(let j:number = 0; j < 3; j++) {
                        const symbol = <DirtyWildsStateReelSymbol>Reels.getSymbol(i, j);
                        if (symbol && !(symbol.controller._isRandomSyncFeatureTriggered && (symbol.controller.reelId === 0 || symbol.controller.reelId === 4))) {
                            this.addNoWinSymbolAnimationToTimeline(timeline, symbol);
                        }
                }
        }
        let adjacentBetLineWinData:IAdjacentBetLineWinData  = <IAdjacentBetLineWinData>betLineWinData;
        if(adjacentBetLineWinData.lineStart == "Right"){
            for(let i:number = adjacentBetLineWinData.winPosition.length - 1; i >= 0; i--) {
                this.setSymbolToggleAnim(adjacentBetLineWinData, i, timeline, 0.17 * ((adjacentBetLineWinData.winPosition.length - 1) - i));
            }
        }
        else {
            for (let i: number = 0; i < adjacentBetLineWinData.winPosition.length; i++) {
                this.setSymbolToggleAnim(adjacentBetLineWinData, i, timeline, 0.17 * i);
            }
        }
        return timeline;
    }

    private setSymbolToggleAnim(adjacentBetLineWinData:IAdjacentBetLineWinData, index:number, timeline:TimelineLite, startTime:number):void{
        if (adjacentBetLineWinData.winPosition[index]) {
            const symbol = Reels.getSymbol(index, adjacentBetLineWinData.betLine[index]);
            if (symbol) {
                this.addSymbolWinAnimationToTimeline(adjacentBetLineWinData, timeline, startTime, symbol);
                this._winSymbols.push(symbol);
            }
        }
    }

    protected addSymbolWinAnimationToTimeline(betLineWinData:IBetLineWinData, timeline:Timeline, startTime:number, symbol:StateReelSymbol):void {
        timeline.add(symbol.changeState({
            state : DirtyWildsGameConfig.instance.SYMBOL_STATES.individualWin,
            fadeInDuration : 0,
            replay : true
        }), startTime);
    }

    protected addNoWinSymbolAnimationToTimeline(timeline:Timeline, symbol:StateReelSymbol):void {
        timeline.add(symbol!.changeState({
            state : DirtyWildsGameConfig.instance.SYMBOL_STATES.noWin,
            fadeInDuration : 0
        }), 0);
    }

}